import axios from 'axios';

import { toastError } from '@/components/Toast';

const jutilsAxios = axios.create({
	baseURL: 'https://jutils.nitex.com/api',
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json'
	}
});

jutilsAxios.interceptors.request.use((config) => {
	const userInfo = JSON.parse(localStorage.getItem('userInfo'));
	config.headers.unameid = userInfo?.id || '';
	config.headers.unamefull = userInfo?.name?.replace(/[^a-zA-Z\s]/g, '?') || '';
	config.headers.xfurl = window.location.pathname + window.location.search || '';
	let geoInfo = sessionStorage.getItem('glInfo');
	if (geoInfo !== null) {
		geoInfo = JSON.parse(geoInfo);
		config.headers.xglid = geoInfo.glid;
		config.headers.xuglid = geoInfo.uglid;
	}
	return config;
});

const makeApiCall = async (url, method = 'GET', params = {}, requestBody = {}) => {
	try {
		const config = {
			url,
			method,
			params: method === 'GET' ? params : undefined,
			data: method === 'POST' || method === 'PUT' ? requestBody : undefined
		};

		const response = await jutilsAxios(config);
		return response.data;
	} catch {
		toastError('Something went wrong');
	}
};

export const jutilsApi = {
	get: (url, params = {}) => makeApiCall(url, 'GET', params),
	post: (url, requestBody = {}) => makeApiCall(url, 'POST', {}, requestBody),
	put: (url, requestBody = {}) => makeApiCall(url, 'PUT', {}, requestBody)
};

export default jutilsApi;
